import MainWrapper from './services/benit/central-ui/components/Container/MainWrapper';

const Main = () => {
    return <MainWrapper />;
};

export default Main;
